export default __webpack_public_path__ + "static/media/959.a8d5d102.png";